enum ItemFilteringType {
  Currencies = "Currencies",
  TransactionAmount = "TransactionAmount",
  PaymentAmount = "PaymentAmount",
}

export default ItemFilteringType;
